/* eslint-disable */
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';
import { ORDER_API_DATE_FORMAT } from '../../../../Constants/Order/Order.constants';
import dateOnly from '../../../../Support/DateTime/DateOnly/DateTimeDateOnly.support';
import getFilters from '../../Filters/Selectors/Filters.selector';
import getFiltersSelectedAddresses from '../../Filters/Selectors/FiltersSelectedAddresses.selector';
import sortedOrdersSelector from './OrdersSorted.selector';

/**
 * Sorts the orders by date range
 * @returns {any} order
 * @param {any} filters filters
 */
const sortedOrdersByDateRangeSelector = createSelector(
  getFilters,
  getFiltersSelectedAddresses,
  sortedOrdersSelector,
  (filters, selectedAddresses, orders) => {
    const { startDate, numberOfDays } = filters;

    const byDateGroup = orders.reduce((acc, order, i) => {
      if (isEmpty(order)) {
        return acc;
      }

      const {
        summary: { startTime, title },
      } = order;

      const isAddressMatching = includes(selectedAddresses, title);
      const hasAddresses = selectedAddresses && selectedAddresses.length > 0;

      if (hasAddresses && !isAddressMatching) {
        return acc;
      }

      const dateKey = dateOnly(startTime, ORDER_API_DATE_FORMAT);
      return {
        ...acc,
        [dateKey]: acc[dateKey] ? [...acc[dateKey], order] : [order],
      };
    }, {});

    const byAllDates = Array.from({ length: numberOfDays }, (v, k) => {
      const dateOffset = addDays(startDate, k);
      const dateKey = format(dateOffset, ORDER_API_DATE_FORMAT);
      return { date: dateKey, orders: byDateGroup[dateKey] || [] };
    });

    return byAllDates;
  },
);

export default sortedOrdersByDateRangeSelector;
